/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.NotificationReport = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The NotificationReport model module.
   * @module model/NotificationReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>NotificationReport</code>.
   * @alias module:model/NotificationReport
   * @class
   */
  var exports = function() {
    var _this = this;













  };

  /**
   * Constructs a <code>NotificationReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/NotificationReport} obj Optional instance to populate.
   * @return {module:model/NotificationReport} The populated <code>NotificationReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('StakeholderID')) {
        obj['StakeholderID'] = ApiClient.convertToType(data['StakeholderID'], 'Integer');
      }
      if (data.hasOwnProperty('DetailsURL')) {
        obj['DetailsURL'] = ApiClient.convertToType(data['DetailsURL'], 'String');
      }
      if (data.hasOwnProperty('DetailsURLParameters')) {
        obj['DetailsURLParameters'] = ApiClient.convertToType(data['DetailsURLParameters'], Object);
      }
      if (data.hasOwnProperty('ContentVariables')) {
        obj['ContentVariables'] = ApiClient.convertToType(data['ContentVariables'], Object);
      }
      if (data.hasOwnProperty('UserID')) {
        obj['UserID'] = ApiClient.convertToType(data['UserID'], 'Integer');
      }
      if (data.hasOwnProperty('TimeStamp')) {
        obj['TimeStamp'] = ApiClient.convertToType(data['TimeStamp'], 'Date');
      }
      if (data.hasOwnProperty('Icon')) {
        obj['Icon'] = ApiClient.convertToType(data['Icon'], 'String');
      }
      if (data.hasOwnProperty('ContentTemplate')) {
        obj['ContentTemplate'] = ApiClient.convertToType(data['ContentTemplate'], 'String');
      }
      if (data.hasOwnProperty('Identifier')) {
        obj['Identifier'] = ApiClient.convertToType(data['Identifier'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {Integer} StakeholderID
   */
  exports.prototype['StakeholderID'] = undefined;
  /**
   * @member {String} DetailsURL
   * @default ''
   */
  exports.prototype['DetailsURL'] = '';
  /**
   * @member {Object} DetailsURLParameters
   */
  exports.prototype['DetailsURLParameters'] = undefined;
  /**
   * @member {Object} ContentVariables
   */
  exports.prototype['ContentVariables'] = undefined;
  /**
   * @member {Integer} UserID
   */
  exports.prototype['UserID'] = undefined;
  /**
   * @member {Date} TimeStamp
   */
  exports.prototype['TimeStamp'] = undefined;
  /**
   * @member {String} Icon
   * @default ''
   */
  exports.prototype['Icon'] = '';
  /**
   * @member {String} ContentTemplate
   * @default ''
   */
  exports.prototype['ContentTemplate'] = '';
  /**
   * @member {String} Identifier
   * @default ''
   */
  exports.prototype['Identifier'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


